/**
 * Theme footer
 * - Mobile menu accordions are always available.
 * - Reveal animation remains optional and follows the section setting.
 */
if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onAccordionClick = this.onAccordionClick.bind(this);
      this.onAccordionKeydown = this.onAccordionKeydown.bind(this);
    }

    connectedCallback() {
      this.setupMobileAccordions();

      const revealEnabled = this.dataset.revealAnimation === 'true';
      this.animations_enabled = revealEnabled &&
        document.body.classList.contains('animations-true') &&
        typeof gsap !== 'undefined';

      if (document.body.classList.contains('template-product-quick-view')) {
        this.animations_enabled = false;
      }
      if (!this.animations_enabled) return;

      this.content = document.getElementById('main-content');
      this.wrapper = document.getElementById('wrapper');
      if (!this.content || !this.wrapper) return;

      this.footer_bg = window.getComputedStyle(document.documentElement).getPropertyValue('--color-footer-bg');
      this.radius = window.getComputedStyle(document.documentElement).getPropertyValue('--block-border-radius');
      this.setupAnimations();
    }

    setupMobileAccordions() {
      this.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
        button.setAttribute('aria-expanded', button.classList.contains('active') ? 'true' : 'false');
        button.addEventListener('click', this.onAccordionClick);
        button.addEventListener('keydown', this.onAccordionKeydown);
      });
    }

    onAccordionClick(event) {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;
      const button = event.currentTarget;
      const isOpen = button.classList.toggle('active');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    onAccordionKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!window.matchMedia('(max-width: 1023px)').matches) return;
      event.preventDefault();
      event.currentTarget.click();
    }

    setupAnimations() {
      const mm = gsap.matchMedia();
      this.wrapper.style.backgroundColor = this.footer_bg;
      mm.add({
        isDesktop: '(min-width: 1024px)',
        reduceMotion: '(prefers-reduced-motion: reduce)'
      }, (context) => {
        const { isDesktop, reduceMotion } = context.conditions;
        gsap.to(this.content, {
          '--footer-border-radius': !isDesktop || reduceMotion ? '0px' : `${this.radius}`,
          '--footer-width-percent': !isDesktop || reduceMotion ? '0%' : '4%',
          duration: 0.5,
          inherit: false,
          ease: 'none',
          modifiers: {
            '--footer-border-radius': x => Math.round(parseFloat(x)) + 'px',
            '--footer-width-percent': x => Math.round(parseFloat(x) * 100) / 100 + '%'
          },
          scrollTrigger: {
            trigger: this,
            fastScrollEnd: true,
            scrub: 1,
            start: () => 'top bottom',
            end: () => 'bottom bottom'
          }
        });
      });
    }
  }
  customElements.define('theme-footer', ThemeFooter);
}
